module.exports = __webpack_public_path__ + "static/img/pic-04@2x.c82f55c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/m/pic-04@2x.png
// module id = mfWr
// module chunks = 1